import NameDescriptionModule from './text/NameDescriptionModule'
import ClientModule from './text/ClientModule'
import WorkersModule from './workers/WorkersModule'
import DateModule from './date/DateModule'
import LineItemsModule from './lineItems/LineItemsModule'
import PhotosModule from './photos/PhotosModule'
import MaterialsModule from './materials/MaterialsModule'
import ClockJobExtendedModule from './clockJob/ClockJobExtendedModule'
import ClockingWorkerModule from './clockJob/ClockingWorkerModule'
import { AssistantsModule, LaborersModule } from './text/LabelsModule'
import BatchJobNameModule from './text/BatchJobNameModule'
import ClockJobTeamModule from './clockJob/ClockJobTeamModule'
import NotesModule from './notes/NotesModule'
import NotesTeamModule from './notes/NotesTeamModule'
import TasksModule from './tasks/TasksModule'
import StatusModule from './status/StatusModule'

const ModulesConfig = {

  displayName: {
    title: 'Job',
    module: NameDescriptionModule
  },

  contactInfo: {
    title: 'Client',
    module: ClientModule
  },

  workers: {
    title: 'Crew Members',
    module: WorkersModule
  },

  date: {
    title: 'Date',
    module: DateModule
  },

  lineItems: {
    title: 'Line Items',
    subtitle: 'Details',
    module: LineItemsModule,
    props: {
      moduleRef: 'lineItems'
    }
  },

  photos: {
    title: 'Photos',
    subtitle: 'Show all',
    module: PhotosModule,
    props: {
      moduleRef: 'photos'
    }
  },

  materials: {
    title: 'Materials',
    subtitle: 'Show all',
    module: MaterialsModule,
    props: {
      moduleRef: 'materials'
    }
  },

  clockingExtended: {
    title: 'Time',
    module: ClockJobExtendedModule,
    props: {
      moduleRef: 'clockingExtended'
    }
  },

  clockingWorker: {
    title: 'Total Work Time',
    module: ClockingWorkerModule,
    props: {
      moduleRef: 'clockingWorker'
    }
  },

  clockingLineItems: {
    title: 'Time',
    module: ClockingWorkerModule,
    hideOnCreate: true,
    props: {
      moduleRef: 'clockingLineItems'
    }
  },

  assistants: {
    title: 'Assistants',
    module: AssistantsModule,
    hideOnCreate: true,
    props: {}
  },

  laborers: {
    title: 'Laborers',
    module: LaborersModule,
    hideOnCreate: true,
    props: {}
  },

  batchName: {
    title: 'Jobs',
    module: BatchJobNameModule,
    props: {}
  },

  clockingTeam: {
    title: 'Times',
    module: ClockJobTeamModule,
    props: {}
  },

  notes: {
    title: 'Notes',
    module: NotesModule,
    hideOnCreate: true,
    props: {}
  },

  notesTeam: {
    title: 'Notes',
    module: NotesTeamModule,
    hideOnCreate: true,
    props: {}
  },

  sharedNotesTeam: {
    title: 'Notes',
    module: NotesTeamModule,
    hideOnCreate: true,
    props: {}
  },

  notesExtended: {
    title: 'Notes',
    subtitle: 'Show all',
    module: NotesTeamModule,
    hideOnCreate: true,
    props: {
      moduleRef: 'notesExtended'
    }
  },

  tasks: {
    title: 'Tasks',
    module: TasksModule,
    props: {}
  },

  sharedTasks: {
    title: 'Tasks',
    module: TasksModule,
    props: {}
  },

  tasksRecurrent: {
    title: 'Recurrent Tasks',
    module: TasksModule,
    props: {}
  },

  tasksInstance: {
    module: TasksModule,
    hideOnCreate: true,
    props: {}
  },

  status: {
    title: 'Status',
    module: StatusModule,
    hideOnCreate: true,
    props: {}
  },

  reminders: {
    title: 'Reminders',
    hideOnCreate: true,
    props: {}
  }

}

export default ModulesConfig



// WEBPACK FOOTER //
// ./src/schedule/common/modules/ModulesConfig.js